import React from 'react';
import { DEFAULT_LANGUAGE } from 'common/constants/values';

export const LanguageContext = React.createContext({
    languageContext: {
        language: DEFAULT_LANGUAGE,
        setLanguage: () => {},
    },
});
